import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { StickyBottomBorder } from 'owa-editor-docking-plugin';
import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';

const styles = require('./FullComposeLeftPane.scss');
const SCROLL_CONTAINER_SELECTOR = '.customScrollBar';

const FullComposeStickyBottomBorder = observer(function FullComposeStickyBottomBorder() {
    const { docking, bodyViewState } = getFullComposeViewState();

    if (!docking.useStickyDocking) {
        return null;
    }

    return (
        <StickyBottomBorder
            editorViewState={bodyViewState}
            dockingViewState={docking}
            scrollContainerSelector={SCROLL_CONTAINER_SELECTOR}
            className={styles.stickyBottomBorder}
        />
    );
});

export default FullComposeStickyBottomBorder;
